/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Provision_By_AgentInputs */

const cs_reports_provision_by_agent = /** @type {(inputs: Reports_Provision_By_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provize podle makléře`)
};

const en_reports_provision_by_agent = /** @type {(inputs: Reports_Provision_By_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provision by agent`)
};

/**
* | output |
* | --- |
* | "Provision by agent" |
*
* @param {Reports_Provision_By_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_provision_by_agent = /** @type {((inputs?: Reports_Provision_By_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Provision_By_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_provision_by_agent(inputs)
	return cs_reports_provision_by_agent(inputs)
});